export default "__VITE_ASSET__B7K6JXNp__"